module.exports = {"440233001":"丰城街道","440233100":"黄礤镇","440233101":"马头镇","440233102":"梅坑镇","440233103":"沙田镇","440233104":"遥田镇","440233105":"回龙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440233.json
// module id = 1792
// module chunks = 0